<template>
  <div class="home">
      <LoginLogout/>
      <div>
        <VideoPlayer v-bind:ott="$route.query.ott"/>
      </div>
  </div>
</template>

<script>
// @ is an alias to /src
import LoginLogout from '@/components/LoginLogout.vue'
import VideoPlayer from '@/components/VideoPlayer.vue'

export default {
  name: 'Home',
  components: {
    LoginLogout,
    VideoPlayer
  },
  data() {
            return {
                title: process.env.VUE_APP_TITLE
            }
  }
}
</script>
